module.exports = "https://static.wmbcdn.com/uniweb/images/036080aa4d8be6c6c7fbadf00a585933.svg";